import { render, staticRenderFns } from "./welfareTicketContent.vue?vue&type=template&id=0c04e973&scoped=true&"
import script from "./welfareTicketContent.vue?vue&type=script&lang=js&"
export * from "./welfareTicketContent.vue?vue&type=script&lang=js&"
import style0 from "./welfareTicketContent.vue?vue&type=style&index=0&id=0c04e973&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c04e973",
  null
  
)

export default component.exports